<!-- 保单信息 -->
<template>
  <div>
    <!-- @submit="handleSubmit" -->
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-row>
        <div class="title_">
          <div class="cutleft_">保单信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" label="保险期限">
            <a-row>
              <a-date-picker :disabled="disabledAll" @change="effectiveDateChange" class :disabled-date="disabledDate" placeholder="保险起期" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" v-decorator="['applicantInfo.effectiveDate', { rules: [{ required: true, message: '请选择投保期限' }] }]" />～
              <a-date-picker :disabled="true" placeholder="保险止期" :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" v-model="applicantInfoExpireDate" />
            </a-row>
            <a-row>
              <a-radio-group name="radioGroup" @change="changeData()" v-model="mon">
                <a-radio :value="1">1个月</a-radio>
                <a-radio :value="2">2个月</a-radio>
                <a-radio :value="3">3个月</a-radio>
                <a-radio :value="4">4个月</a-radio>
                <a-radio :value="5">5个月</a-radio>
                <a-radio :value="6">6个月</a-radio>
                <a-radio :value="7">7个月</a-radio>
                <a-radio :value="8">8个月</a-radio>
                <a-radio :value="9">9个月</a-radio>
                <a-radio :value="10">10个月</a-radio>
                <a-radio :value="11">11个月</a-radio>
                <a-radio :value="12">12个月</a-radio>
              </a-radio-group>
            </a-row>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业名称">
            <a-input v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" :disabled="disabledAll" placeholder="请输入投保企业名称" @blur="queryCompanyCodeByName()"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12" class="mg_left_20">
          <a-form-item :label-col="{ span: 6 }" label="行业类别">
            <a-select :disabled="disabledAll" placeholder="请选择" :showSearch="true"
              :filter-option="filterOption" v-decorator="['applicantInfo.industrycode', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option v-for="(item, index) in companyCatagoryList" :key="index + 'i2'" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              :default-value="applicantInfo.idType"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }]
                }
              ]"
              placeholder="请选择投保企业证件类型"
              @change="queryCompanyCodeByName"
            >
              <a-select-option value="03">统一社会信用代码</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" class="mg_left_20">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.idNumber',
                {
                  rules: [
                    { required: true, message: '请输入投保企业证件号码' },
                  ]
                }
              ]"
              placeholder="请输入投保企业证件号码"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24" class="mg_left_20">
          <a-form-item :label-col="{ span: 3 }" label="投保人证件有效期">
            <a-date-picker :disabled="disabledAll" placeholder="证件止期" style="width: 300px;" v-decorator="['applicantInfo.invalidate', { rules: [{ required: true, message: '请选择证件止期' }] }]" />
            <br /><span style="color: red;font-size: 14px;">提示：证件为长期的填写9999-12-31</span>
          </a-form-item>
        </a-col>
        <a-col :span="12" class="mg_left_20">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }]
                }
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12" class="mg_left_20">
          <a-form-item :label-col="{ span: 6 }" label="联系人手机号码">
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [{ required: true, message: '请输入联系人手机号码' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }]
                }
              ]"
              placeholder="用于接收承保短信"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12" class="mg_left_20">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [{ required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }]
                }
              ]"
              placeholder="用于接收电子保单及电子发票"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="企业地址">
            <a-cascader
              placeholder="请选择"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }]
                }
              ]"
              :options="pacOptions"
              :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children'
              }"
              style="float: left; width: 250px;"
            />
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }]
                }
              ]"
              placeholder="请输入联系地址"
              style="float: left; width: 350px;"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12" class="mg_left_20">
          <a-form-item :label-col="{ span: 6 }" label="法人代表">
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.projectaddress',
                {
                  rules: [{ required: true, message: '请输入法人代表' }]
                }
              ]"
              placeholder="请输入法人代表姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select :disabled="disabledAll" placeholder="请选择支付类型" @change="(value) => handleChange(value, 'payMethod')" v-decorator="['applicantInfo.payMethod', { rules: [{ required: true, message: '请选择支付类型' }] }]">
              <a-select-option value="3">在线支付</a-select-option>
              <a-select-option value="88">凭证支付</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <label class="ant-form-item-required" style="position: relative;top: 10px;left:0px;float: left;"></label>
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件图片">
            <a-upload
              name="multipartFile"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              action="/api/file/upload"
              accept="image/*"
              :before-upload="beforeUploadImg"
              @change="
                e => {
                  return handleChangeImg(e, 1);
                }
              "
            >
              <img v-if="imageUrlUpload" :src="imageUrlUpload" alt="avatar" style="max-width: 300px" />
              <div v-else>
                <a-icon :type="imageUploadLoading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <label class="ant-form-item-required" style="position: relative;top: 10px;left:0;float: left;"></label>
          <a-form-item :label-col="{ span: 6 }" label="投保人声明">
            <!-- accept="image/*,application/pdf" -->
            <a-upload
              style="width: 50%"
              name="multipartFile"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              action="/api/file/upload"
              accept="image/*"
              :before-upload="beforeUploadImg2"
              @change="
                e => {
                  return handleChangeImg(e, 2);
                }
              "
            >
              <div>
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <a class="download" href="https://image.ssish.com/static/product/GFTYX20H/file/4投保人声明-互联网产品专用（宇泰0215）.docx">下载投保人声明</a>
            <div v-if="companyfilepath2.length > 0">
              <!--pdf-->
              <a class="upload-file" v-if="!isImgType" :href="companyfilepath2[0]" target="_blank" :download="calcImageName(companyfilepath2[0])">{{ calcImageName(companyfilepath2[0]) }}</a>
              <!--图片-->
              <div class="img-div" v-if="isImgType">
                <a :href="item" target="_blank" v-for="(item, i) in companyfilepath2" :key="i">
                  <img :src="item" />
                  <p class="del" @click.stop.prevent="companyfilepath2.splice(i, 1)">删除</p>
                </a>
              </div>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- 被保人列表 -->
      <salInsuredList :disabledAll="disabledAll" :columns="columns" :data="salInsuredList" @delSelect="delSelectpre" @addSelect="addSelectpre" @EduitSelect="eduitSelect"></salInsuredList>
      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>

      <a-row>
        <a-row>环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件发送电子发票，请注意查收。</a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="发票类型">
            <a-select placeholder="请选择" @change="invoiceprinttypeChange" v-decorator="['applicantInfo.invoiceprinttype', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option value="-1">暂不开票</a-select-option>
              <a-select-option value="1">电子发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="applicantInfo.invoiceprinttype != -1">
          <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input v-decorator="['applicantInfo.taxpayercertificateno', { rules: [{ required: true, message: '请输入纳税人识别号' }] }]" placeholder="请输入纳税人识别号"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row style="color: red;">若需要专票，去帮助中心申请；如单位不符合抵扣规定，建议选择电票。批单发票类型与契约（新单、首单的发票类型一致）。</a-row>

      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
          <a-col>
            <a-button class="btn_color" type="primary" :disabled="disabledAll" @click="changePremium">修改保费</a-button>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom:20px">
          投保人已充分阅读、理解并同意
          <fileView  :insureContent="planContent"></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" v-show="!disabledAll" @click="handleSubmit('save')" :loading="submitLoad2">
              <!-- html-type="submit" -->
              保存订单
            </a-button>
            <a-button class="btn_color" type="primary" v-show="disabledAll" @click="goBack()">返回编辑</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="handleSubmit()" :loading="submitLoad2">立即投保</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div v-for="(item, key) in addPcontent" v-if="RiskInfos.premiumBaseDtoList[key - 1] && RiskInfos.premiumBaseDtoList[key - 1].personNum > 0" :key="key">
        <div>
          请输入职业{{ key }}保费(如不输入则按原值({{ viewPcontent[key] }})计算)：
          <a-input-number class="level_" :min="parseFloat(viewPcontent[key])" v-model="addPcontent[key]" />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal :afterClose="handlePayModalClose" class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p
        style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 30px 20px 0;
          line-height: 30px;
        "
      >
        您投保的国富1-6类需支付保费
        <span style="color: #fe8f2d; font-weight: bold">
          {{ applicantInfo.totalPremium }} </span
        >&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import utils from './../js/utils';
import moment from 'moment';
import salInsuredList from './salInsuredList';
import fileView from './fileview';
import { policyMixin } from '@/mixins/policyMixin.js';
import planHtml from '../js/insuranceInfo.js'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    salInsuredList,fileView
  },
  mixins: [policyMixin],
  data() {
    //这里存放数据
    return {
      planHtml,
      occuRiskPremium: '', //每个职业大类
      yueduBtn: false, //阅读中
      submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      companyCatagoryList: utils.companyCatagoryList, //行业类别
      invoiceprinttype: '', //发票类型
      /**需要的数据开始 */
      applicantInfo: {
        name: '', //投保企业名称
        idType: '', //证件类型
        idNumber: '', //证件号码
        imageUrl: '', //证件图片
        pacCode: '', //省市区
        address: '', //详细地址
        // companyProperty: "", //企业性质
        industrycode: '', //行业类别
        contactsname: '', //联系人名称
        telephone: '', //联系人电话
        email: '', // 邮箱
        // beneficiary: "", // 附加被保险人
        remark: '', //备注
        invoiceprinttype: '', //发票类型
        taxpayercertificateno: '', //纳税人识别号
        payMethod: '3', //支付方式
        totalPremium: 0, //总保费
        juvenilesAvgpremuim: 0, //单个保费
        expireDate: '',
        effectiveDate: '' //投保期限
      },
      address: '',
      //表格的头部
      columns: utils.columns,
      //表格的数据
      salInsuredList: [],
      rate: 0.2, //费率
      industrycodeTEXT: '', //四级行业的文本
      maxType: 1, //最大类别
      companyCode: '01', //企业性质
      planinfos: '0;0;0', //基础保费
      perRiskInfo: '', //险种类
      evidenceNumber: '', //凭证号
      uniqueArr: [], //去重后的人数列表
      orderContent: {},
      industrycode: '', // 行业类别
      imageUrlUpload: '', //图片上传返显
      imageUrlUpload2: '', //图片上传返显， 影像件
      isImgType: true, //授权委托书,是否是上传的图片类型
      companyfilepath: '', //企业证件
      companyfilepath2: [], //授权委托书
      imageUploadLoading: false, //
      //投保人证件类型
      companyIdTypeOptions: utils.companyIdTypeOptions,
      //投保的天数
      loading: false,
      form: this.$form.createForm(this, {
        name: 'advanced_search'
      }),
      flightnumber: [], //投保大类暂存
      RiskInfos: {
        architecture: '0',
        riskInfos: [
          {
            riskCode: '2114104', //意外伤害身故、残疾
            dutyCode: '410406',
            dutyMult: 1,
            amount: 100000,
            premiumAmt: 0,
            riskName: `意外伤害身故、残疾`,
            riskAmountDesc: 100000
          }
        ],
        salPolicy: {
          productCode: '', //产品code
          bracket: 12, //保费期限
          planCode: ''
        },
        salPolicyHolderExt: {
          industryname: '' //行业Name
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      resultPcontent: {},
      viewPcontent: {}, //展示的保费
      addPcontent: {}, //拷贝的
      creator: '1',
      productCode: '',
      plan: '',
      userParams: {},
      /**需要的数据结束 */
      guapre: 1,
      mon: 12,
      planOffsetDay: 0,
      baodanData: {
        startdata: ''
      },
      startValues: null,
      disabledAll: false,
    };
  },
  computed: {
    planContent() {
      let planCode = this.$route.query.planCode
      if(planCode === 'GFTYX20Htwo') {
        return this.planHtml.planTwoHtml
      }
      return this.planHtml.planOneHtml
    },
    applicantInfoExpireDate() {
      let mon = this.mon;
      let date = this.applicantInfo.effectiveDate;
      if (date != '') {
        return moment(date)
          .add(mon, 'M')
          .subtract(1, 's');
      } else {
        return date
      }
    },
    pacOptions() {
      let twoArrCode = '宜宾市内江市威海市聊城市赤峰市铁岭市四平市双鸭山市哈尔滨市鸡西市信阳市开封市焦作市鹤壁市廊坊市南平市宿州市安庆市';
      let threeCode = '大英县江阳区都江堰市栖霞市栖霞市莱州市金乡县桦南县道里区新密市内黄县通许县文峰区元氏县丛台区青龙满族自治县三河市兴隆县滨海新区静海区罗定市古田县平谷区密云区怀柔区莒县原阳县鄢陵县';
      let dataArr = window.addrescode;
      dataArr&&dataArr.forEach(e => {
        e.children.forEach(element => {
          if (twoArrCode.indexOf(element.text) > -1) {
            element['disabled'] = true;
          }
          element.children.forEach(elements => {
            if (threeCode.indexOf(elements.text) > -1) {
              elements['disabled'] = true;
            }
          });
        });
      });
      return dataArr;
    }
  },
  //监控data中的数据变化
  watch: {
    'applicantInfo.pacCode'(val) {
      sessionStorage.removeItem('pacCode');
      sessionStorage.setItem('pacCode', val[2].value || null);
    },
    'applicantInfo.name'(val) {
      if (val.indexOf('天津') != -1) {
        this.applicantInfo.name = '';
        this.form.setFieldsValue({
          applicantInfo: {
            name: ''
          }
        });
        this.$message.warning('天津地区企业不可投保');
      }
    }
  },
  //方法集合
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    goBack() {
      //返回编辑
      this.disabledAll = false;
      this.$bus.$emit('disabledBus', false);
      let obj = this.$route.query;
      this.$router.push({
        path: 'guofu',
        query: {
          u: obj.u,
          p: obj.p,
          planCode: obj.planCode,
          sign: obj.sign
        }
      });
    },
    queryCompanyCodeByName(idType) {
      if(idType) {
        this.applicantInfo.idType = idType
      }
      if(!this.applicantInfo.idType) {
        return
      }
      this.blurCompanyName(1)
    },
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[0]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(window.addrescode);
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          var threeArr = twoArr[0].children.filter(item => item[str] == arr[2]) || [];
          sessionStorage.setItem('pacCode', threeArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0], threeArr[0]]
        };
      }
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            this.orderContent = res.data.content;
            this.$store.commit('setOrderContent', this.orderContent);
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.salInsuredList = res.data.content.salInsuredList;
              this.salInsuredList.forEach((element, i) => {
                element.occupation = [element.occupationCode.substring(0, 3), element.occupationCode.substring(0, 5), element.occupationCode]; //职业类别代码
                element['index'] = i + 1;
              });
            }
            if (res.data.content.riskInfos) {
              let riskInfos = res.data.content.riskInfos;
              this.RiskInfos.riskInfos = riskInfos;
              this.$bus.$emit('busRiskInfos', this.$lodash.cloneDeep(riskInfos));
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.mon = parseInt(salPolicy.optionalFlag);
              this.flightnumber = salPolicy.flightnumber.split(',');
              this.applicantInfo.mon = parseInt(salPolicy.bracket);
              this.applicantInfo.totalPremium = salPolicy.totalPremium;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.applicantInfo.juvenilesAvgpremuim = salPolicy.juvenilesAvgpremuim;
              this.creator = salPolicy.creator;
              this.applicantInfo.effectiveDate = moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss')
                },
                baodanData: {
                  startdata: moment(salPolicy.effectiveDate).format('YYYY-MM-DD')
                }
              });
            }
            if (res.data.content.salPolicyExt) {
              let salPolicyExt = res.data.content.salPolicyExt;
              this.occuRiskPremium = salPolicyExt.occuRiskPremium;
            }
            if (res.data.content.salPolicyHolderExt) {
              let salPolicyHolderExt = res.data.content.salPolicyHolderExt;
              this.industrycodeTEXT = salPolicyHolderExt.industryname;
            }
            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;

              let companyfilepath = (salPolicyHolder.companyfilepath || '').split(',');
              this.imageUrlUpload = companyfilepath[0] || '';
              this.companyfilepath = companyfilepath[0] || '';
              this.companyfilepath2 = companyfilepath.slice(1);
              this.isImgTypeFunc(this.companyfilepath2[0]);
              this.$bus.$emit('busStature', salPolicyHolder.stature), //"是否高空，是：1，否：2，默认2"
                (this.applicantInfo.name = res.data.content.salPolicyHolder.name);
              this.address = salPolicyHolder.address;
              this.applicantInfo.invoiceprinttype = salPolicyHolder.invoiceprinttype;
              sessionStorage.setItem('HYCode', salPolicyHolder.industrycode);
              this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).arrCode;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).code,
                  industrycode: salPolicyHolder.industrycode
                }
              });
              this.$nextTick(() => {
                this.form.setFieldsValue({
                  applicantInfo: {
                    taxpayercertificateno: salPolicyHolder.taxpayercertificateno
                  }
                });
              });
            }
            this.salInsuredList = res.data.content.salInsuredList;
            this.RiskInfos.premiumBaseDtoList = this.numResult(res.data.content.salInsuredList); //人员类别，处理成每一类的人数
            this.RiskInfos.salPolicy = {...this.RiskInfos.salPolicy, ...res.data.content.salPolicy};
            this.RiskInfos.salPolicyHolder = {...this.RiskInfos.salPolicyHolder, ...res.data.content.salPolicyHolder};
            this.RiskInfos.salPolicyHolder.addfifty = '1';
          }
        }
      });
    },
    emailChange(e) {
      let val = e.target.value;
      if (!this.$checkEmail.test(val)) {
        this.form.setFieldsValue({
          applicantInfo: {
            email: ''
          }
        });
        this.$message.error('请输入正确的联系人邮箱', 3);
      }
    },
    idPhoneChange(e) {
      let val = e.target.value;
      if (!this.$checkPhone.test(val)) {
        this.form.setFieldsValue({
          applicantInfo: {
            telephone: ''
          }
        });
        this.$message.error('请输入正确的联系人手机号', 3);
      }
    },
    //确认修改
    handleOk() {
      let numResult = 0;
      this.salInsuredList.forEach(element => {
        element.premium = this.addPcontent[element.occulevel] - 0;
        numResult += element.premium;
      });
      let premiumBaseDtoList = this.RiskInfos.premiumBaseDtoList;
      let occuRiskPremium = JSON.parse(this.occuRiskPremium);
      let premiumAmt410406 = this.resultPcontent['410406'] - 0;
      premiumBaseDtoList.forEach(element => {
        let element410406 = 0;
        if (element.personNum > 0) {
          let addPer = this.addPcontent[element.occupationKind] * 1000000;
          let oriPer = this.viewPcontent[element.occupationKind] * 1000000;
          let difference = addPer - oriPer;
          let num = occuRiskPremium[element.occupationKind - 1][5];
          let oriAll = occuRiskPremium[element.occupationKind - 1][0] * 1000000;
          let addAll = oriAll + difference * num;
          let addAll6 = addPer * num;
          element410406 = difference * num;
          occuRiskPremium[element.occupationKind - 1][0] = addAll / 1000000;
          occuRiskPremium[element.occupationKind - 1][6] = addAll6 / 1000000;
          premiumAmt410406 += element410406 / 1000000 - 0;
          this.occuRiskPremium = JSON.stringify(occuRiskPremium);
        }
      });
      this.resultPcontent['410406'] = premiumAmt410406;
      this.applicantInfo.totalPremium = numResult.toFixed(2);
      this.modalVisible = false;
    },
    //修改保费
    changePremium() {
      if (JSON.stringify(this.resultPcontent) == '{}') {
        this.$message.error('您还没有计算保费');
        return;
      }
      this.modalVisible = true;
    },
    //统计次数
    numResult(data) {
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      return d;
    },
    //委托书的名称
    calcImageName(fileUrl) {
      return fileUrl.slice(fileUrl.lastIndexOf('/') + 1);
    },
    //文件是否是图片类型
    isImgTypeFunc(file) {
      if (!file) {
        return;
      }
      if (file.slice(file.lastIndexOf('.') + 1).toUpperCase() == 'PDF') {
        this.isImgType = false;
      } else {
        this.isImgType = true;
      }
    },
    beforeUploadImg(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片类型文件');
      }
      const isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('图片必须小于5M');
      }
      return isJpgOrPng && isLt2M;
    },
    beforeUploadImg2(file) {
      if (this.companyfilepath2.length == 0) {
        return true;
      }
      let name = file.name;
      let isImg = name.slice(name.lastIndexOf('.') + 1).toUpperCase() != 'PDF';
      if (this.isImgType == isImg) {
        return true;
      } else {
        this.$message.error('两次上传文件类型不一致');
        return false;
      }
    },
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },
    //type 1:企业证件  2:影像件
    handleChangeImg(info, type) {
      if (info.file.status === 'uploading') {
        if (type == 1) {
          this.imageUploadLoading = true;
        }
        return;
      }
      if (info.file.status === 'done') {
        let response = info.file.response;
        if (response.returnCode != '00') {
          this.$message.error(response.returnMsg);
          return;
        }
        if (type == 1) {
          this.companyfilepath = info.file.response.content;
          this.getBase64(info.file.originFileObj, imageUrl => {
            this.imageUrlUpload = imageUrl;
          });
        } else {
          this.imageUrlUpload2 = info.file.response.content;
          this.isImgTypeFunc(info.file.response.content);
          if (this.isImgType) {
            //图片资源
            this.companyfilepath2.push(info.file.response.content);
          } else {
            //pdf只允许上传一张
            this.companyfilepath2 = [info.file.response.content];
          }
          this.$forceUpdate();
        }
        this.imageUploadLoading = false;
        console.log(this.applicantInfo, 'this.applicantInfo===>');
      }
    },
    //试算的接口
    resultPremiumSum(data) {
      let copyData = this.$lodash.cloneDeep(data);
      copyData.premiumBaseDtoList.forEach(e => {
        e.occupationKind = e.occupationKind.toString().slice(0, 1);
      });
      console.log(copyData)
      let formData = {
        architecture: copyData.architecture,
        riskInfos: copyData.riskInfos, //险种信息
        salPolicy: {
          planCode:  copyData.salPolicy.planCode || this.$route.query.planCode, //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
          creator: this.creator,
          optionalFlag: this.mon //保费期限
        },
        salPolicyHolder: {
          addfifty: '2',
          name: this.applicantInfo.name
        },
        salInsuredList: this.salInsuredList,
        premiumBaseDtoList: copyData.premiumBaseDtoList //人数
      };
      this.$api
        .calPremiumEmployer(formData)
        .then(res => {
          if (res.data.success) {
            let datas = res.data.content;
            this.resultPcontent = datas;
            this.viewPcontent = this.$lodash.cloneDeep(datas.occuLevelSingalPrem); //恒定不变的展示用，做限制
            this.addPcontent = utils.resoverObj(this.$lodash.cloneDeep(datas.occuLevelSingalPrem)); //计算用的改变的数据
            this.occuRiskPremium = datas.perOccuPerRiskTotalPremium;
            this.occuLevelDutyPremium = datas.occuLevelDutyPremium;
            this.$nextTick(() => {
              this.salInsuredList = datas.salInsuredList;
            });
            let flightnumber = [];
            this.salInsuredList.forEach(element => {
              //投保职业大类
              if (element.occulevel) {
                let str = `G100${element.occulevel}`;
                if (flightnumber.indexOf(str) == '-1') {
                  flightnumber.push(str);
                }
              }
            });
            this.duty_fee_structure = data.perOccuPerRiskTotalPremium;
            this.flightnumber = flightnumber;
            this.applicantInfo.totalPremium = datas.totalPremium;
          } else {
            this.$message.error(res.data.returnMsg + '错误');
          }
        })
        .catch(() => {
          this.applicantInfo.totalPremium = 0;
        });
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.applicantInfo.invoiceprinttype = value;
    },

    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date;
    },
    //开始时间
    disabledDate(current) {
      return (current && current > moment().add(1, 'months')) || (current && current < moment());
    },
    filterSalInsuredList(data) {
      return data.filter(e => {
        delete e['occupation'];
        delete e['mobile'];
        delete e['termOfValidity'];
        delete e['uniqueid'];
        delete e['type'];
        delete e['height'];
        switch (e['gender']) {
          case '男':
            e['gender'] = 'M';
            break;
          case '女':
            e['gender'] = 'F';
            break;
        }
        return e.occulevel;
      });
    },
    //最后的提交
    handleSubmit(type) {
      debugger;
      this.form.validateFields((err, values) => {
        if (!err) {
          if (type == 'save') {
            //保存
            let base = this.applicantInfo;
            if (this.RiskInfos.premiumBaseDtoList.length < 3) {
              this.$message.warning('投保人须为团体，每张保单不少于3人投保，且需投保同一方案。');
              return;
            }
            // 联系人姓名只能为中文/^[\u4e00-\u9fa5]+$/
            if(!/^[\u4e00-\u9fa5]+$/.test(values.applicantInfo.contactsname)) {
              this.$message.error(`联系人姓名只能输入中文`, 3);
              return;
            }
            if (!this.companyfilepath) {
              this.$message.error(`请上传投保企业证件图片`, 3);
              return;
            }
            if (this.companyfilepath2.length == 0) {
              this.$message.error(`请上传投保人声明`, 3);
              return;
            }
            let riskInfos = this.RiskInfos && this.RiskInfos.riskInfos.filter(item => item.amount != 0);
            riskInfos.forEach(element => {
              if (this.resultPcontent[element.dutyCode]) {
                element.premiumAmt = this.resultPcontent[element.dutyCode];
              }
            });
            // debugger
            let data = {
              salInsuredList: this.filterSalInsuredList(this.salInsuredList), //表格的数据
              salPolicy: {
                //保单信息
                planCode: this.plan, //产品计划 （固定值ConstructAccident）
                productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
                creator: this.creator,
                optionalFlag: this.mon,
                id: this.policyId,
                flightnumber: this.flightnumber.join(','),
                effectiveDate: moment(values.applicantInfo.effectiveDate).format('YYYY-MM-DD'), //startTime  保单生效时间
                expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
                payMethod: values.applicantInfo.payMethod, //支付方式”
                totalPremium: base.totalPremium, //totalPremium  总保费
                coverageamount: '', //totalSumInsured  总保额
                remark: values.applicantInfo.remark, //备注
                ordertraceno: '' //"凭证支付时的凭证号",
              },
              salPolicyHolder: {
                //投保人信息
                addfifty: '2', //测算类型
                type: 'C', //固定值
                projectaddress: values.applicantInfo.projectaddress,
                companyfilepath: `${this.companyfilepath},${this.companyfilepath2.join(',')}`,
                schooltype: this.RiskInfos.salPolicyHolder.stature == '1' ? 'Y' : 'N',
                gztypestr: `${this.addPcontent[1]},${this.addPcontent[2]},${this.addPcontent[3]},${this.addPcontent[4]},${this.addPcontent[5]},${this.addPcontent[6]}`,
                name: values.applicantInfo.name, //name  投保人名称
                idType: values.applicantInfo.idType, //证件类型
                idNumber: values.applicantInfo.idNumber, //certNo   证件号码
                address: values.applicantInfo.address, //详细地址
                contactsname: values.applicantInfo.contactsname, //联系人姓名
                contactsphone: values.applicantInfo.contactsphone, //联系人电话
                province: base.pacCode[0].text,
                city: base.pacCode[1].text,
                district: base.pacCode[2].text,
                invalidate: moment(values.applicantInfo.invalidate).format('YYYY-MM-DD'), //证件有效期
                email: values.applicantInfo.email, //联系人邮箱
                industrycode: values.applicantInfo.industrycode, //行业类型
                stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
                addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2].value}`,
                invoiceprinttype: values.applicantInfo.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
                taxpayercertificateno: values.applicantInfo.taxpayercertificateno //税务号
              },
              salPolicyHolderExt: {
                industryname: this.industrycodeTEXT
              },
              salPolicyExt: {
                occEmpVersion: this.fileCodeContent.id,
                occuRiskPremium: this.occuRiskPremium,
                isworkheightinvolved: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
                architecture: this.RiskInfos.architecture // 是否是建筑行业
              },
              riskInfos: riskInfos
            };
            this.postPolicyData = data;
            // return
            if (this.$route.query.policyId) {
              this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
            }
            this.submitLoad2 = true;
            this.axiosPolicy('save'); // 保存订单是 直接保存
          } else {
            if (!this.yueduBtn) {
              this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
              return;
            }
            this.submitLoad2 = true;
            this.groupUnderwriting();
          }
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    groupUnderwriting() {
      //核保
      let data = {
        policyId: this.$route.query.policyId
      };
      this.$api
        .groupUnderwriting(data)
        .then(res => {
          if (res.data.returnCode == '0000') {
            this.showPaySure = true;
          }
        })
        .catch(() => {
          this.submitLoad2 = false;
        });
    },
    axiosPolicy(save) {
      //提交保单
      if (save == 'save') {
        this.$api
          .GFemployerPolicy(this.postPolicyData)
          .then(res => {
            if (res.data.returnCode == '00') {
              this.showPaySure = false;
              this.policyId = res.data.content;
              this.$message.success('保存成功！');
              this.$router.push({
                name: 'guofu',
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  planCode: this.$route.query.planCode,
                  sign: this.$route.query.sign,
                  policyId: this.policyId
                }
              });
              this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
            }
          })
          .finally(() => {
            this.submitLoad2 = false;
          });
      }
    },
    paySure() {
      //支付确认
      debugger
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: 'guofu', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
        name: this.applicantInfo.name,
      });
    },
    handlePayModalClose() {
      this.showPaySure = false;
      this.submitLoad2 = false;
    },
    handleChange(value, type, label) {
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
        this.address = label.length > 2 ? label[0].text + label[1].text + label[2].text : '';
        sessionStorage.setItem('pacCode', value[2]);
      } else if (type == 'industrycode') {
        sessionStorage.setItem('HYCode', value);
        this.industrycodeTEXT = label ? label[3].text : '';
        this.applicantInfo[type] = value;
        this.industrycode = value; //行业类型
        if (value[1] == 'C21') {
          //家具制造业 限制地区
          let name = this.applicantInfo.name;
          if (name.indexOf('江门') != -1) {
            this.applicantInfo.name = '';
            this.form.setFieldsValue({
              applicantInfo: {
                name: ''
              }
            });
            this.$message.warning('此地区不可投保家具制造业');
          }
        }
      } else {
        this.applicantInfo[type] = value;
      }
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$bus.$on('onRiskInfos', data => {
      let strdata = this.$lodash.cloneDeep(data);
      this.RiskInfos.architecture = strdata.architecture;
      this.RiskInfos.riskInfos = strdata.riskInfos;
      this.RiskInfos.salPolicy = strdata.salPolicy
      this.mon = Number(strdata.salPolicy.optionalFlag);
      if (strdata.salPolicyHolder.name) {
        this.form.setFieldsValue({
          applicantInfo: {
            name: strdata.salPolicyHolder.name
          }
        });
      }
      if (this.salInsuredList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off('onRiskInfos');
    this.$bus.$off('resultPcontent');
  } //生命周期 - 销毁之前
};
</script>
<style scoped>
.address-fix >>> .ant-form-explain {
  margin-left: 50px;
}
.upload-file {
  width: 100%;
  height: 25px;
  display: block;
  color: #0077ff;
  text-decoration: underline;
}
.img-div {
  display: flex;
}
.img-div a {
  display: block;
  position: relative;
  margin-right: 10px;
}
.img-div img {
  width: 112px;
  height: 112px;
}
.img-div .del {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 25px;
  line-height: 25px;
  background: rgba(0, 0, 0, 0.5);
  color: red;
  margin: 0;
  padding: 0;
  text-align: center;
}
</style>
<style lang="scss">
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}
.download {
  vertical-align: top;
}
.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}

.user {
  .ant-select,
  .ant-calendar-picker,
  .ant-cascader-picker {
    pointer-events: none !important;
  }

  #myCal {
    pointer-events: none !important;
  }
}
</style>
